import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const OuterSection = styled.section`
  display: flex;
  flex: 1;
  border-color: #1bace4;
  border-style: dashed;
  align-items: center;
  align-self: center;
  text-align: center;
  justify-content: center;
  transition: border 0.24s ease-in-out;
  border-width: 2px;
  border-radius: 5px;
  padding: 0px;
  backgroundcolor: #fff;
  color: #474747;
  width: ${(props) => props.width ?? "65%;"};
`;

export const ParagraphText = styled.p`
  color: #767676;
  font-style: italic;
  font-weight: 400;
  font-size: 16px;
  text-align: right;
  align-content: center;
  padding: 15px 10px;
  margin: 0px !important;
  text-align: center;
`;

export const DocumentRow = styled.div`
  margin-top: ${(props) => props.marginTop ?? "40px"};
`;

export const FileName = styled.p`
  line-height: 2;
  color: #084987;
  position: absolute;
  top: -30px;
  position: relative;
  margin: 0;
  margin-bottom: 5px;
  font-family: Lato;
  font-size: 14px;
`;

export const DeleteSpan = styled.span`
  border-radius: 40px;
  width: auto;
  margin-left: 7px;
`;

export const FileInputLabel = styled.label`
  width: auto;
  color: #1bace4;
  font-family: "Lato";
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 1;
  text-align: center;
  text-align: left;
`;
